import gql from 'graphql-tag';

import {
  printPartnerOrderServiceDetails,
  printPartnerShippingOptionDetails,
} from '../../../../graphql/fragments/print-partner';

const getPrintPartners = gql`
  query getPrintPartners($id: RecordID, $name: String) {
    printPartners(print_partner_id: $id, name: $name) {
      total
      records {
        id
        name
        api_type
        currency
        print_products {
          total
        }
        order_services {
          total
          records {
            ...printPartnerOrderServiceDetails
          }
        }
        shipping_options(slice: { limit: 999 }) {
          total
          records {
            ...printPartnerShippingOptionDetails
          }
        }
      }
    }
  }
  ${printPartnerOrderServiceDetails}
  ${printPartnerShippingOptionDetails}
`;

export default getPrintPartners;
